import { render, staticRenderFns } from "./momoPayment.vue?vue&type=template&id=28e3d664"
import script from "./momoPayment.vue?vue&type=script&lang=js"
export * from "./momoPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports